import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";
import { paymentsApi } from "@/lib/apiClient";
import { PassportLogo } from "@/components/Reveal";
import { useTranslation } from "react-i18next";

export default function PaymentSuccess() {
    const { t } = useTranslation();
    const [sp] = useSearchParams();
    const sessionId = sp.get("session_id");
    const [status, setStatus] = useState({ payment_status: "pending", tier: null });
    const [tries, setTries] = useState(0);

    useEffect(() => {
        if (!sessionId) return;
        let cancelled = false;
        const poll = async () => {
            try {
                const r = await paymentsApi.status(sessionId);
                if (cancelled) return;
                setStatus(r);
                if (r.payment_status !== "paid" && tries < 15) {
                    setTimeout(() => setTries((t) => t + 1), 2000);
                }
            } catch (e) {}
        };
        poll();
    }, [sessionId, tries]);

    const paid = status.payment_status === "paid";

    return (
        <div className="min-h-screen grid place-items-center px-6 grain" data-testid="payment-success">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
                className="max-w-lg w-full text-center rounded-3xl p-10"
                style={{ background: "var(--navy-deep)", border: "1px solid rgba(212,175,55,0.25)" }}
            >
                <div className="w-20 h-20 mx-auto mb-8 rounded-full grid place-items-center"
                    style={{ background: "rgba(212,175,55,0.1)", border: "1px solid var(--gold)" }}>
                    {paid ? <CheckCircle size={40} weight="fill" color="#D4AF37" /> : <PassportLogo size={44} />}
                </div>
                <div className="overline mb-4">{paid ? t("paymentSuccess.boardingPassIssued") : t("paymentSuccess.processing")}</div>
                <h1 className="font-serif text-4xl md:text-5xl text-white leading-tight tracking-tight mb-4">
                    {paid ? (
                        <>{t("paymentSuccess.welcomePrefix")}<span style={{ fontStyle: "italic", color: "var(--gold-pale)" }}>{status.tier || t("conciergeApp.passport")}</span>{t("paymentSuccess.welcomeSuffix")}</>
                    ) : (
                        t("paymentSuccess.finalisingBooking")
                    )}
                </h1>
                <p className="text-white/60 leading-relaxed mb-10">
                    {paid
                        ? t("paymentSuccess.subscriptionLiveSub")
                        : t("paymentSuccess.holdTightSub")}
                </p>
                <Link to={paid ? "/app" : "/"} className="btn-gold" data-testid="payment-continue">
                    {paid ? t("paymentSuccess.openDashboard") : t("paymentSuccess.backToPassport")}
                    <ArrowRight size={14} />
                </Link>
            </motion.div>
        </div>
    );
}
